import styled from 'styled-components';
import { lineHeight } from '../style';

export const ErrorMessage = styled.label`
  margin-top: ${lineHeight / 2}px;
  display: block;
  color: var(--error-text-color);
`;
